export const PoemOnAccidents = () => {
    return (
        <div id="014" className="">
            <p>cracked beetle shell, a ruckus,</p>
            <p>a victim of circumstance,</p>
            <p>how can you truly know if you're ready</p>
            <p>to face the world?</p>
            <p>dragonfly wings, </p>
            <p>evidently, separated from the body,</p>
            <p>a never ending pushing action against the skin,</p>
            <p>
                the strain of shielding your eyes from the sun again and again.
            </p>
            <p>out there, so many uncounted</p>
            <p>casualties of despair,</p>
            <p>truth be told, i am scared of the world, </p>
            <p>that it might very well eat me alive,</p>
            <p>at night i often dream of myself running away from it,</p>
            <p>that it might catch me and judge me for all of my</p>
            <p>shameful unripeness.</p>
            <br />
            <p>who's ever really ready for the world?</p>
            <p>thoughts cramped into my throat and sinuses,</p>
            <p>and back of the skull,</p>
            <p>who's ever really ready to face everybody else?</p>
            <p>each pair of eyes, people's gazes like </p>
            <p>unlit tunnels and dark alleyways,</p>
            <p>moments like steep riverbanks,</p>
            <p>how can you know that you're able to cross the water</p>
            <p>and come out alive?</p>
            <br />
            <p>maybe some questions are pointless,</p>
            <p>
                in the end, some answers can only be found at the bottom of the
                river,
            </p>
            <p>some things grow only under the scorching sun,</p>
            <p>some things never change,</p>
            <p>some things always feel the same,</p>
            <p>some things will scratch and maim you</p>
            <p>
                and only in that moment, when you feel the fangs piercing the
                skin,
            </p>
            <p>as if your flesh is the soft fruit getting bitten into,</p>
            <p>will the thought come that</p>
            <p>
                "oh, there's no way i could have known it was going to be like
                this."
            </p>
        </div>
    );
};
